import React from 'react'

import SyllabusProject from '../SyllabusProject'

import { API } from 'src/api'
import WistiaVideoEmbed from 'src/components/WistiaVideoEmbed'

export { default as FRAGMENT } from './fragments'

type Props = API.SyllabusListProjectVideoComponent & { position: number }

const SyllabusProjectVideo: React.FC<React.PropsWithChildren<Props>> = ({
  title,
  description,
  videoId,
  position,
}) => (
  <SyllabusProject
    title={title}
    position={position}
    description={description}
    header={<WistiaVideoEmbed id={videoId} title={title} backgroundColor="WARM_BLUE_30" />}
  />
)

export default SyllabusProjectVideo
